<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app clipped color="#FBDDDD">
      <v-list class="pt-0" dense>
        <template v-for="item in items">
          <v-list-item :key="item.text" :to="item.link">
            <v-list-item-content>
              <v-layout justify-center>
                <v-list-item-action>
                  <v-icon color="#482F12">{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title class="itemstyle">{{ item.text }}</v-list-item-title>
              </v-layout>
            </v-list-item-content>
          </v-list-item>
          <v-divider :key="item.icon"></v-divider>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left color="#E17A82" dense height="60px">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" large></v-app-bar-nav-icon>
      <v-toolbar-title class="mr-12 align-center">
        <span class="headtoolbar">Patra Sweet House</span>
      </v-toolbar-title>

      <div class="flex-grow-1"></div>
      <v-menu left bottom :offset-y="true" transition="scroll-y-transition">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon large>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-card class="mx-auto" width="200">
          <v-list-item-group>
            <v-list>
              <v-list-item v-for="(profile, index) in profiles" :key="index">
                <v-list-item-title @click="clickitem(profile.method)" style="font-family: Kanit;">
                  <v-icon color="#30343D" class="mr-3">{{ profile.icon }}</v-icon>
                  {{ profile.title }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-list-item-group>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-content style="background-color:white">
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import swal from 'sweetalert'
export default {
  props: {
    source: String
  },
  data: () => ({
    drawer: null,
    items: [],
    itemsa: [
      {
        icon: 'mdi-cart-plus',
        text: 'จัดการสินค้า',
        link: '/manageproducts',
        listicon: false
      },
      {
        icon: 'mdi-currency-usd',
        text: 'จัดการราคาสินค้า',
        link: '/manageproductprices',
        listicon: false
      },
      {
        icon: 'mdi-check',
        text: 'อนุมัติรายการสั่งสินค้า',
        link: '/approveorder',
        listicon: false
      },
      {
        icon: 'mdi-publish mdi-flip-v',
        text: 'Export รายการสั่งสินค้า',
        link: '/exportorder',
        listicon: false
      },
      {
        icon: 'mdi-truck-fast',
        text: 'การจัดส่งสินค้า',
        link: '/deliveryorder',
        listicon: false
      },
      {
        icon: 'mdi-check-all',
        text: 'การชำระเงิน',
        link: '/approvepayment',
        listicon: false
      },
      {
        icon: 'mdi-clipboard-text-outline',
        text: 'ประวัติการสั่งสินค้า',
        link: '/orderhistory',
        listicon: false
      },
      {
        icon: 'mdi-arrow-right-bold-circle-outline',
        text: 'สรุปยอดขาย',
        link: '/summarysales',
        listicon: false
      },
      {
        icon: 'mdi-account-multiple-outline',
        text: 'จัดการร้านค้า',
        link: '/managemember',
        listicon: false
      },
      {
        icon: 'mdi-account-key-outline',
        text: 'จัดการเจ้าหน้าที่',
        link: '/manageadmin',
        listicon: false
      },
      {
        icon: 'mdi-account-card-details-outline',
        text: 'จัดการบัญชี',
        link: '/managebank',
        listicon: false
      }
    ],
    itema: [
      {
        icon: 'mdi-check',
        text: 'อนุมัติรายการสั่งสินค้า',
        link: '/approveorder',
        listicon: false
      },
      {
        icon: 'mdi-publish mdi-flip-v',
        text: 'Export รายการสั่งสินค้า',
        link: '/exportorder',
        listicon: false
      },
      {
        icon: 'mdi-truck-fast',
        text: 'การจัดส่งสินค้า',
        link: '/deliveryorder',
        listicon: false
      },
      {
        icon: 'mdi-check-all',
        text: 'การชำระเงิน',
        link: '/approvepayment',
        listicon: false
      },
      {
        icon: 'mdi-clipboard-text-outline',
        text: 'ประวัติการสั่งสินค้า',
        link: '/orderhistory',
        listicon: false
      },
      {
        icon: 'mdi-arrow-right-bold-circle-outline',
        text: 'สรุปยอดขาย',
        link: '/summarysales',
        listicon: false
      }
    ],
    itemc: [
      {
        icon: 'mdi-truck-fast',
        text: 'การจัดส่งสินค้า',
        link: '/deliveryorder',
        listicon: false
      }
    ],
    profiles: [
      { title: 'Recent export', icon: 'mdi-download-outline', method: 'recentexport' },
      { title: 'Logout', icon: 'mdi-home-outline', method: 'logout' }
    ],
    profiledatas: 'login'
  }),
  created () {
    if (this.$cookies.get('status') !== '') {
      this.items =
      this.$cookies.get('status') === 'super admin'
        ? this.itemsa
        : this.$cookies.get('status') === 'admin'
          ? this.itema
          : this.itemc
    } else {
      this.$router.push('/')
    }
  },
  methods: {
    goroute (item) {
      this.$router.push(item)
    },
    clickitem (item) {
      if (item === 'recentexport') {
        this.$router.push('/recentexport')
      } else {
        this.logout()
      }
    },
    logout () {
      try {
        this.$cookies.set('token', '')
        this.$cookies.set('status', '')
        window.location.replace('/')
      } catch (error) {
        swal({
          title: `ระบบผิดพลาด`,
          text: 'กรุณาลองอีกครั้งในภายหลัง',
          icon: `warning`,
          dangerMode: true,
          buttons: 'ตกลง'
        })
      }
    }
  }
}
</script>

<style>
.headtoolbar {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 30px;
  color: #ffffff;
}
.itemstyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 33px;
  color: #482f12;
}
.v-list--dense .v-list-item {
  min-height: 55px !important;
}
.swal-overlay--show-modal .swal-modal {
  font-family: 'Kanit' !important;
}
.swal-title {
  font-size: 20px;
}
.swal-button--danger {
  background-color: #E17A82;
  border: 0px;
  width: 100px;
}
.v-data-table {
  font-family: 'Kanit';
}
.v-text-field {
  font-family: 'Kanit';
}
p {
  font-family: 'Kanit';
}
.v-date-picker {
  font-family: 'Kanit';
}
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
